import { ref, onMounted } from 'vue'
import { useProjectStore } from '@/store/project'
import { useUnitStore } from '@/store/unit'
import { useBuildingStore } from '@/store/building'

export function useEmbed() {
    const embed = ref(false)

    const { project: projectSlug } = useRoute().params
    const { building: buildingSlug } = useRoute().params
    const { unit: unitId } = useRoute().params

    const projectStore = useProjectStore()
    const buildingStore = useBuildingStore()
    const unitStore = useUnitStore()

    const showCards = ref(true)
    const showCarousel = ref(true)
    const showTimeOfDay = ref(true)
    const showCompass = ref(true)
    const showFullScreen = ref(true)
    const showSnapshot = ref(true)
    const showShare = ref(true)
    const showInteriorOptions = ref(true)
    const showMinimap = ref(true)
    const showFloorLevel = ref(true)
    const defaultInteriorOptionId = ref(null)
    const defaultWaypointIndex = ref(null)
    const colors = ref(null)
    const buildingCardCallback = ref(null)
    const unitCardCallback = ref(null)
    const mouseSensitivity = ref(1)
    const buildingChooserTimeOfDay = ref(null)
    const initialized = ref(false)
    const unitDataOverrides = ref(null)
    const language = ref(null)

    const initalizeIFrame = () => {
        window.onmessage = async (e) => {
            if (e.data) {
                if (e.data.type === 'initialized') {
                    showCards.value = e.data.showCards
                    showCarousel.value = e.data.showCarousel
                    showTimeOfDay.value = e.data.showTimeOfDay
                    showCompass.value = e.data.showCompass
                    showFullScreen.value = e.data.showFullScreen
                    showSnapshot.value = e.data.showSnapshot
                    showShare.value = e.data.showShare
                    showInteriorOptions.value = e.data.showInteriorOptions
                    showMinimap.value = e.data.showMiniMap
                    showFloorLevel.value = e.data.showFloorLevel
                    defaultInteriorOptionId.value = e.data.defaultInteriorOptionId
                    defaultWaypointIndex.value = parseInt(e.data.defaultWaypointIndex)
                    colors.value = e.data.colors
                    mouseSensitivity.value = e.data.mouseSensitivity
                    buildingChooserTimeOfDay.value = e.data.buildingChooserTimeOfDay

                    if (colors) {
                        for (const key in colors.value) {
                            delete colors.value[key].isSold
                            delete colors.value[key].hidePage
                        }
                    }

                    buildingCardCallback.value = e.data.buildingCardCallback
                        ? new Function('return' + e.data.buildingCardCallback)()
                        : null
                    unitCardCallback.value = e.data.unitCardCallback
                        ? new Function('return' + e.data.unitCardCallback)()
                        : null

                    // TODO: review this

                    if (e.data.unitDataOverrides) {
                        unitDataOverrides.value = e.data.unitDataOverrides
                    }

                    if (e.data.mouseSensitivity) {
                        mouseSensitivity.value = e.data.mouseSensitivity
                    }

                    if (e.data.language) {
                        language.value = e.data.language
                    }

                    initialized.value = true
                    embed.value = true
                } else if (e.data.type === 'filter') {
                    // call the filters module
                    // updateFilter({
                    //     field: this.filters[e.data.key].field,
                    //     value: e.data.value
                    // })
                } else if (e.data.type === 'reset') {
                    // call the filters module
                    // resetFilters()
                }
            }
        }

        const data = {
            type: 'initialized',
            statuses: projectStore.projectWithFieldsAndStatuses.statuses,
            fields: projectStore.projectWithFieldsAndStatuses.fields,
            project: projectStore.projectWithFieldsAndStatuses,
            buildings: buildingStore.buildings,
            building: buildingSlug ? buildingStore.building : undefined,
            units: unitStore.units ? unitStore.units : undefined,
            unit: unitId ? unitStore.unit : undefined
        }

        const parsedData = JSON.parse(JSON.stringify(data))

        window.parent.postMessage(parsedData, '*')
    }

    const hoverOverUnit = (context) => {
        hoverOver(context, 'unit')
    }

    const hoverOutUnit = (context) => {
        hoverOut(context, 'unit')
    }

    const hoverOverBuilding = (context) => {
        hoverOver(context, 'building')
    }

    const hoverOutBuilding = (context) => {
        hoverOut(context, 'building')
    }

    const hoverOver = (context, scope) => {
        if (embed.value) {
            window.parent.postMessage(
                {
                    type: 'hover-over',
                    scope,
                    [scope]: context
                },
                '*'
            )
        }
    }

    const hoverOut = (context, scope) => {
        if (embed) {
            window.parent.postMessage(
                {
                    type: 'hover-out',
                    scope,
                    [scope]: context
                },
                '*'
            )
        }
    }

    const beforeRouteLeave = (to, _from, next) => {
        if (embed.value) {
            let path
            if (!to.path.startsWith('/embed')) {
                path = `/embed${to.path}`
            } else {
                path = to.path
            }
            window.parent.postMessage(
                {
                    type: 'nav',
                    path,
                    ...to.params,
                    statuses: projectStore.projectStatuses,
                    fields: projectStore.projectFields,
                    project: {
                        project: projectStore.projectWithFieldsAndStatuses,
                        buildings: buildingStore.buildings
                    },
                    building: buildingSlug ? buildingStore.building : undefined,
                    unit: unitId ? unitStore.unit : undefined
                },
                '*'
            )
        }
    }

    return {
        embed,
        showCards,
        showCarousel,
        showTimeOfDay,
        showCompass,
        showFullScreen,
        showSnapshot,
        showShare,
        showInteriorOptions,
        showMinimap,
        showFloorLevel,
        defaultInteriorOptionId,
        defaultWaypointIndex,
        colors,
        buildingCardCallback,
        unitCardCallback,
        mouseSensitivity,
        buildingChooserTimeOfDay,
        initialized,
        language,
        unitDataOverrides,
        initalizeIFrame,
        hoverOverUnit,
        hoverOutUnit,
        hoverOverBuilding,
        hoverOutBuilding,
        hoverOver,
        hoverOut,
        beforeRouteLeave
    }
}
